module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.elementId
    }
  }, [_c('div', {
    staticClass: "btn-group"
  }, _vm._l((_vm.buttons), function(item) {
    return _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.clickHandler(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('auto-responsive', _vm._b({
    ref: "autoresponsive"
  }, 'auto-responsive', _vm.options, false), _vm._l((_vm.arrayList), function(item) {
    return _c('div', {
      staticClass: "item",
      style: (_vm.style)
    }, [_vm._v(_vm._s(item))])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-835bc2a2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./homepage/simplest.vue
// module id = 155
// module chunks = 0